import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=d68bf06e&scoped=true"
var script = {}
import style0 from "./Nav.vue?vue&type=style&index=0&id=d68bf06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68bf06e",
  null
  
)

export default component.exports